import { api } from '../../shared/http/ApiClient.js';
import { BaseViewModel } from '../../shared/viewmodels/BaseViewModel.js';
import { HomeRepository } from '../models/repositories/HomeRepository.js';
import type { HomeData } from '../models/entities/HomeData.js';

interface State {
  loading: boolean;
  data: HomeData | null;
  error: string | null;
  /** true si el estado vino del server (SSR): no hay que volver a pedirlo. */
  hydrated: boolean;
}

/**
 * ViewModel de la portada. Recibe el estado que resolvió el loader en el server; si lo
 * tiene, `load()` no hace nada — el HTML del server no se pisa con un fetch redundante.
 * `load()` real corre solo en navegación client-side.
 */
export class HomeViewModel extends BaseViewModel<State> {
  private readonly repo = new HomeRepository({ get: (p) => api.get(p) });

  constructor(initial: HomeData | null = null) {
    super({
      loading: false,
      data: initial,
      error: null,
      hydrated: initial !== null,
    });
  }

  async load(): Promise<void> {
    if (this.state$.value.hydrated) return; // ya vino del server

    this.patch({ loading: true, error: null });
    try {
      const data = await this.repo.home();
      this.patch({ data, loading: false });
    } catch (err) {
      this.patch({ loading: false, error: (err as Error).message });
      this.emit('error', err);
    }
  }
}
